import { BaseMapper } from '@ps/utils';
import { SurveyQuestionCategory } from '@ps/survey-utils';

import { SurveyQuestionCategoryDto } from '../dtos/survey-question.dto';

export class SurveyCategoryMapper extends BaseMapper<
  SurveyQuestionCategoryDto,
  SurveyQuestionCategory
> {
  public fromDto(dto: SurveyQuestionCategoryDto): SurveyQuestionCategory {
    return {
      id: dto.id,
      label: dto.label,
    };
  }
}
